import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=5fe4312f&"
import script from "./Widgets.vue?vue&type=script&lang=js&"
export * from "./Widgets.vue?vue&type=script&lang=js&"
import style0 from "./Widgets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe4312f')) {
      api.createRecord('5fe4312f', component.options)
    } else {
      api.reload('5fe4312f', component.options)
    }
    module.hot.accept("./Widgets.vue?vue&type=template&id=5fe4312f&", function () {
      api.rerender('5fe4312f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets.vue"
export default component.exports